import React from 'react'
import { FaAngleLeft } from "react-icons/fa";
import { SubMenuList, TopSubMenu } from './SidebarSubMenu';
import { SubMenuItem } from './SidebarSubMenuItem';
import { Left } from './SidebarMenu';
import { useNavigate } from 'react-router-dom';

export default function SidebarCucuMenu({ judul, cucuMenuList, toggleCucuMenu, toggleSidebar }) {
  const navigate = useNavigate()
  const onClick = () => {
      navigate('/lists')
      toggleSidebar()
  }
  return (
    <>
        <TopSubMenu onClick={toggleCucuMenu}>
            <FaAngleLeft/>
            <p>{judul}</p>
        </TopSubMenu>
        <SubMenuList>
            {
                cucuMenuList && cucuMenuList.map((cucuMenu, idx) => (
                    <SubMenuItem key={idx} onClick={onClick}>
                        <Left>{cucuMenu.title}</Left>
                    </SubMenuItem>
                ))
            }
        </SubMenuList>
    </>
  )
}
